import React, { useEffect } from "react";
import { Grid, Select, Text, TextInput } from "@mantine/core";
import {
  normalizeOrderArFormAccount,
  ORDER_IFAST_PLATFORM_OPTIONS,
  resolveOrderIfastAccountNo,
  setOrderIfastAccountNo,
  setOrderIfastPlatform,
} from "../helpers/arFormUtils";

const SummaryItem = ({ label, value }) => (
  <div>
    <Text size="xs" color="dimmed" mb={2}>
      {label}
    </Text>
    <Text size="xs">{value || "—"}</Text>
  </div>
);

const OrderInvestmentAccount = ({ form, orderSource, readOnly, disabled }) => {
  const locked = Boolean(readOnly || disabled);
  const policyNumber = orderSource?.policyNumber ?? form?.values?.policyNumber;
  const formAccount = normalizeOrderArFormAccount(form?.values?.arForm);
  const savedOrderAccount = normalizeOrderArFormAccount(orderSource?.arForm);
  const resolvedIfastAccountNo = resolveOrderIfastAccountNo({
    policyNumber,
    ifastAccountNo: locked
      ? savedOrderAccount.ifastAccountNo || formAccount.ifastAccountNo
      : formAccount.ifastAccountNo,
  });
  const platform = locked
    ? savedOrderAccount.platform || formAccount.platform
    : formAccount.platform;

  useEffect(() => {
    if (locked || !form) return;
    if (resolvedIfastAccountNo === formAccount.ifastAccountNo) return;
    setOrderIfastAccountNo(form, resolvedIfastAccountNo);
  }, [
    form,
    formAccount.ifastAccountNo,
    locked,
    policyNumber,
    resolvedIfastAccountNo,
  ]);

  const ifastAccountNo = resolvedIfastAccountNo;

  const handleIfastChange = (event) => {
    setOrderIfastAccountNo(form, event.currentTarget.value);
  };

  return (
    <Grid gutter="md">
      <Grid.Col span={12} md={6}>
        {locked ? (
          <SummaryItem
            label="iFAST A/C No. 奕豐戶口號碼"
            value={ifastAccountNo}
          />
        ) : (
          <TextInput
            size="xs"
            label="iFAST A/C No. 奕豐戶口號碼"
            value={ifastAccountNo}
            onChange={handleIfastChange}
          />
        )}
      </Grid.Col>
      <Grid.Col span={12} md={6}>
        {locked ? (
          <SummaryItem label="Platform 平台" value={platform} />
        ) : (
          <Select
            size="xs"
            label="Platform 平台"
            placeholder="Select IGP or Central"
            data={ORDER_IFAST_PLATFORM_OPTIONS}
            value={platform || null}
            onChange={(value) => setOrderIfastPlatform(form, value)}
            clearable
          />
        )}
      </Grid.Col>
    </Grid>
  );
};

export default OrderInvestmentAccount;
